import React from 'react';
import { cn, useBooleanState } from '@gettactic/helpers';
import { LoadingSpinner } from '@cmp-src/loadings/LoadingSpinner';

type ImageProps = {
  src: string;
  alt?: string;
  className?: string;
  wrapperClassName?: string;
};

const classes = {
  Wrapper: 'relative object-cover',
  Loading:
    'absolute inset-0 flex animate-pulse items-center justify-center bg-gray-100',
  Spinner: 'h-8 w-8 animate-spin text-gray-500',
    Image: 'h-full w-full object-cover transition-opacity duration-500'
};

export const Image: React.FC<ImageProps> = ({
  src,
  alt = '',
  className,
  wrapperClassName
}) => {
  const isLoaded = useBooleanState();

  React.useEffect(() => {
    isLoaded.false();
  }, [src]);

  return (
    <div className={cn(classes.Wrapper, wrapperClassName)}>
      {!isLoaded.state && (
        <div className={classes.Loading}>
          <LoadingSpinner />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        key={src}
        className={cn(
          classes.Image,
          !isLoaded.state ? 'opacity-0' : 'opacity-100',
          className
        )}
        onLoad={isLoaded.true}
      />
    </div>
  );
};
